import React, { Component } from "react";
import { connect } from "react-redux";
import WithRoutify from "../../../hoc/WithRoutify";
import Buttons from "../../../components/UI/Buttons";
import WithRouter from "../../../hoc/WithRouter";
import VisitsList from "../../EmployeeVisitContainer/VisitsList";
import { decryptString } from "../../../utils/commonUtils";
import OrganizationService from "../../../services/OrganizationService";
import AssignCompany from "../../../components/Modal/AssignCompany";
import PERMISSIONS from "../../../utils/AclPermissions";
import VisitsLIstNew from "../../EmployeeVisitContainer/NewUIVisitList/VisitsLIstNew";
import EmployeeService from "../../../services/EmployeeService";

class CategoryFilteredVisits extends Component {
  constructor(props) {
    super(props);
    
    // Get category from props
    const { visitCategories = [], title = "Visits" , screenType } = this.props;
    
    this.state = {
      isModelOpen: false,
      assignCompanyModal: false,
      filters: {
        first_name: "",
        last_name: "",
        gender: "",
        company_id: "",
        dob: "",
        patient_id: "",
        phone: "",
        identification_type: "",
        identification_number: "",
        clinic_id: "",
        booking_id: "",
        pre_registration_code: "",
        visit_categories: Array.isArray(visitCategories) ? visitCategories : [visitCategories],
      },
      title,
      screenType,
    };
  }

  componentDidMount = () => {
    const { params } = this.props;
    this.checkEmployeeCompanyAssignment(params.patientId);
  };

  checkEmployeeCompanyAssignment = async (employeeId) => {
    try {
      const employeeData = await EmployeeService.getEmployee(employeeId);
      if (employeeData && (employeeData.company_assigned === 0 || !employeeData.company_id)) {
        this.setState({ assignCompanyModal: true });
      } else {
        this.setState({ assignCompanyModal: false });
      }
    } catch (error) {
      console.error("Error checking employee company assignment:", error);
      this.setState({ assignCompanyModal: false });
    }
  };

  companyAssignToogleHandler = () => {
    this.setState({ assignCompanyModal: false });
    const { params } = this.props;
    this.checkEmployeeCompanyAssignment(params.patientId);
  };

  componentDidUpdate(prevProps) {
    // Handle prop changes if needed
  }

  componentWillUnmount() {
    // Cleanup
  }

  addVisitToogleHandler = () => {
    const { params } = this.props;
    const patientDetails = decryptString(params.patientDetails);
    
    this.setState({
      isModelOpen: !this.state.isModelOpen,
      visitsAutoFillData: {
        company_id: patientDetails.company_id,
        employee_id: params.patientId,
        organization_id: OrganizationService.getOrgId(),
      },
    });
  };

  render() {
    const { params, isNewUI } = this.props;
    const { isModelOpen, visitsAutoFillData, assignCompanyModal, filters, title } = this.state;
    const patientDetails = decryptString(params.patientDetails);

    return (
      <div id="categoryFilteredVisits" className="tab-pane active show" role="tabpanel">
        <div className="sh_innerPortview">
          <div className="p-2">
            <div className="sh_cardBox sh_chartboxht shadow-none border">
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <h6 className="text-sm mb-0">
                    {title} - {patientDetails.patientName}
                  </h6>
                  <div className="addAction d-flex justify-content-between align-items-center">
                    <Buttons
                      title={`Add ${title}`}
                      className="btn btn-icon btn-transparent-dark"
                      acl={PERMISSIONS.VISITS.CREATE}
                      iconType={"AddIconDetailView"}
                      clickHandler={this.addVisitToogleHandler}
                    />
                  </div>
                </div>
              </div>

              {assignCompanyModal && (
                <AssignCompany
                  employeeId={params.patientId}
                  modleToogleHandler={this.companyAssignToogleHandler}
                />
              )}

              {isNewUI ? (
                <VisitsLIstNew
                  isModelOpen={isModelOpen}
                  isFromVisitHistory={true}
                  visitsAutoFillData={visitsAutoFillData}
                  initialFilters={filters}
                  screenType={this.state.screenType}
                />
              ) : (
                <VisitsList
                  isModelOpen={isModelOpen}
                  isFromVisitHistory={true}
                  visitsAutoFillData={visitsAutoFillData}
                  initialFilters={filters}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map Redux state to props
const mapStateToProps = (state) => ({
  isNewUI: state.common.isNewUI,
});

export default connect(mapStateToProps)(WithRouter(WithRoutify(CategoryFilteredVisits)));
